export const workHistory = [
  {
    imageSrc: "/images/susco.png",
    link: "https://suscosolutions.com/",
    company: "Susco",
    roles: [
      {
        title: "Senior Software Engineer",
        date: "Jan 2026 - Present",
        listItems: [
        ],
      },
      {
        title: "Intermediate Software Developer",
        date: "Aug 2024 - Jan 2026",
        listItems: [
          "Analyzed business and technical requirements and translated them into technical specifications, work breakdown structures, and development estimates.",
          "Designed and implemented secure authentication handshakes between a centralized SSO catalog and individual tenant applications, enabling seamless tenant switching.",
          "Built a LiDAR-based room-scanning feature for insurance adjusters using Apple RoomPlan, including custom 3D transformations to clean, normalize, and convert scan data for import into a third-party application.",
          "Developed an AI-assisted claim-intake system that reads adjusters’ emails and attachments, extracts relevant information, and automatically creates claims.",
          "Integrated an AI-powered voice assistant into a mobile application to help users complete tasks and access information through natural-language interactions.",
          "Created a forecasting algorithm that used historical data to estimate tree-removal duration and recommend required equipment.",
        ],
      }
    ]
  },
  {
    imageSrc: "/images/zant.png",
    link: "https://www.zanttech.com/",
    company: "Zant Technologies",
    roles: [
      {
        title: "Software Developer",
        date: "Nov 2021 - Aug 2024",
        listItems: [
          "Built and customized large customer-facing web and mobile applications based on client requirements, including e-commerce platforms and payment processing systems.",
          "Worked across frontend and backend technologies, selecting languages and frameworks based on the needs of each project.",
          "Improved API and database performance by optimizing queries and application logic, reducing response times by as much as 75%.",
          "Engineered data dashboards that allowed clients to track service sign-ups, usage, and other key business metrics.",
          "Collaborated with project teams using Agile and Scrum development practices.",
        ],
      }
    ]
  },
  {
    imageSrc: "/images/sta.bmp",
    link: "https://www.stteresasacademy.org/",
    company: "St. Teresa's Academy",
    roles: [
      {
        title: "Software Developer, Teacher, Registrar",
        date: "Aug 2016 - Apr 2022",
        listItems: [
          "Customized the frontend and backend of the PowerSchool student information system using AngularJS and Oracle SQL.",
          "Automated and digitized manual administrative processes, reducing repetitive work and improving day-to-day operations.",
          "Independently designed, built, and maintained several internal web applications using HTML, CSS, PHP, JavaScript, and MySQL.",
          "Maintained student and school records both digitally and physically. Managed large-scale data operations, including writing scripts to import, export, and reconcile data from multiple sources.",
          "Wrote complex Oracle SQL queries for reporting, data analysis, and operational decision-making.",
          "Created curriculum for and taught courses in Python, Java, 2D and 3D/VR Game Development (Unity + C#), Database Systems (MySQL), and Networks + Security.",
          "Coached the FIRST Tech Challenge robotics team.",
        ],
      }
    ]
  },
  {
    imageSrc: "/images/4d.jpg",
    company: "Team 4th Dimension",
    roles: [
      {
        title: "President",
        date: "Aug 2014 - May 2016",
        listItems: [
          "Co-founded a startup focused on developing web and mobile applications for clients and original product ideas.",
          "Managed company finances, accounts, and administrative operations.",
          "Prepared business and legal documentation.",
          "Supervised team members and coordinated development efforts.",
          "Contributed directly to product strategy, technical development, and project execution.",
        ],
      }
    ]
  },
];
